import React from 'react';

const SpamhausEDROPAdapterDocumentation = () => <div />;

export default SpamhausEDROPAdapterDocumentation;
